import makeStyles from '@material-ui/core/styles/makeStyles';
import {getDate} from '../../../../../../@casino/lib/getDate';

const useStyles = makeStyles(() => ({
    wrapTitle: {
        paddingLeft: 8,
        paddingBottom: '6px',
        marginTop: 20,
        paddingTop: '4px',
        marginBottom: '8px',
        borderBottom: '1px solid #ccc',
        width: '97%',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingRight: 12,
    }, 
    title: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '14px',
        lineHeight: '17px',
        userSelect: 'none',
        fontFamily: 'PT Sans,sans-serif',
        color: '#fff',
    },
    arrow: {
        fill: '#fff', 
        width: 10, 
        height: 10
    }
}))

const getRows = (bonusesArr) => {
    return bonusesArr.map((item) => {
        return {
            id: item.id,
            date: getDate(item.date_event),
            label: item.bonus_label, 
            summ: new Intl.NumberFormat('ru-RU').format(item.amount) + '₽',
            wager: new Intl.NumberFormat('ru-RU').format(item.wager) + '₽',
            status: item.status ? 'Выдано'  : 'Не выдано',
            cause: item.cause
        }
    })
}
 
const columns = [
    { id: 'id', label: 'ID'},
    { id: 'date', label: 'Дата'},
    { id: 'label', label: 'Бонус'},
    { id: 'summ', label: 'Сумма'},
    { id: 'wager', label: 'Wager'},
    { id: 'status', label: 'Статус'},
    { id: 'cause', label: 'Причина'}
];

export {
    useStyles,
    getRows,
    columns
}